// Datos mock para Micro-Bat Landing Page

export const sliderData = [
  {
    id: 0,
    image: "/images/slider-microbat.jpg",
    alt: "Instalaciones Micro-Bat",
    objectPosition: "top"
  },
  {
    id: 1,
    image: "/images/slider1.jpg",
    alt: "Mecanizado de precisión 1"
  },
  {
    id: 2,
    image: "/images/slider2.jpg",
    alt: "Mecanizado de precisión 2"
  },
  {
    id: 3,
    image: "/images/slider3.jpg",
    alt: "Mecanizado de precisión 3"
  }
];

export const piezasData = [
  { id: 1, image: "/images/piezas/pieza1.jpg", alt: "Pieza mecanizada de precisión 1" },
  { id: 2, image: "/images/piezas/pieza2.jpg", alt: "Pieza mecanizada de precisión 2" },
  { id: 3, image: "/images/piezas/pieza3.jpg", alt: "Pieza mecanizada de precisión 3" },
  { id: 4, image: "/images/piezas/pieza4.jpg", alt: "Pieza mecanizada de precisión 4" }
];

export const serviciosData = [
  {
    id: 1,
    slug: "verificacion-tridimensional",
    nombre: "Verificación Tridimensional",
    imagen: "/images/verificacion tridimensional.png",
    descripcion: "Control dimensional de alta precisión"
  },
  {
    id: 2,
    slug: "torneado",
    nombre: "Torneado",
    imagen: "/images/torneado.jpg",
    descripcion: "Mecanizado de piezas cilíndricas"
  },
  {
    id: 3,
    slug: "rectificado",
    nombre: "Rectificado",
    imagen: "/images/rectificado.jpg",
    descripcion: "Acabados superficiales de precisión"
  },
  {
    id: 4,
    slug: "fresado",
    nombre: "Fresado",
    imagen: "/images/fresado.jpg",
    descripcion: "Mecanizado de geometrías complejas"
  },
  {
    id: 5,
    slug: "erosion",
    nombre: "Erosión por Hilo",
    imagen: "/images/erosion.jpg",
    descripcion: "Corte de precisión por electroerosión"
  },
  {
    id: 6,
    slug: "grabado",
    nombre: "Grabado Láser",
    imagen: "/images/maquinas/laser-1.jpg",
    descripcion: "Marcaje y grabado láser de precisión"
  }
];

// Fichas detalladas de cada servicio con sus máquinas y especificaciones
export const serviciosDetalle = {
  "verificacion-tridimensional": {
    slug: "verificacion-tridimensional",
    nombre: "Verificación Tridimensional",
    descripcion:
      "Control dimensional de alta precisión mediante máquinas de medición tridimensional y columnas de medición, garantizando la calidad de cada pieza fabricada.",
    grupos: [
      {
        titulo: null,
        maquinas: [
          {
            nombre: "Columnas de medición Tesa Micro-Hite",
            imagenes: [
              "/images/maquinas/tesa-microhite-1.jpg",
              "/images/maquinas/tesa-microhite-2.jpg"
            ],
            specs: [
              { label: "Recorrido (X·Y·Z)", valor: "500 x 700 x 400 mm" },
              { label: "Peso máximo", valor: "180 kg" }
            ]
          },
          {
            nombre: "Mitutoyo Crysta Plus M 574",
            imagenes: [
              "/images/maquinas/mitutoyo-crysta-1.jpg",
              "/images/maquinas/mitutoyo-crysta-2.jpg"
            ],
            specs: [
              { label: "Recorrido (X·Y·Z)", valor: "500 x 700 x 400 mm" },
              { label: "Peso máximo", valor: "180 kg" }
            ]
          }
        ]
      }
    ]
  },
  torneado: {
    slug: "torneado",
    nombre: "Torneado",
    descripcion:
      "Mecanizado de piezas cilíndricas con tornos CNC de última generación, incluyendo eje Y, subcabezal y herramientas motorizadas para geometrías complejas.",
    grupos: [
      {
        titulo: null,
        maquinas: [
          {
            nombre: "CMZ TL 25 B",
            imagenes: [
              "/images/maquinas/cmz-tl25b-1.jpg",
              "/images/maquinas/cmz-tl25b-2.jpg"
            ],
            specs: [
              { label: "Diámetro torneable", valor: "hasta Ø 420 mm" }
            ]
          },
          {
            nombre: "CMZ TC 25 YS",
            imagenes: [
              "/images/maquinas/cmz-tc25ys-1.jpg",
              "/images/maquinas/cmz-tc25ys-2.jpg"
            ],
            specs: [
              { label: "Configuración", valor: "Eje Y y subcabezal" },
              { label: "Herramientas motorizadas", valor: "16" },
              { label: "Diámetro torneable", valor: "hasta Ø 550 mm" }
            ]
          },
          {
            nombre: "Spinner CNC (decoletaje)",
            imagenes: [
              "/images/maquinas/spinner-1.jpg",
              "/images/maquinas/spinner-2.jpg",
              "/images/maquinas/spinner-3.jpg"
            ],
            specs: [
              { label: "Alimentación", valor: "Con alimentador de barras" }
            ]
          }
        ]
      }
    ]
  },
  rectificado: {
    slug: "rectificado",
    nombre: "Rectificado",
    descripcion:
      "Acabados superficiales de precisión mediante rectificado plano CNC y rectificado cilíndrico universal, alcanzando las tolerancias más exigentes.",
    grupos: [
      {
        titulo: null,
        maquinas: [
          {
            nombre: "Rectificadora CNC plana GER",
            imagenes: [
              "/images/maquinas/ger-plana-1.jpg",
              "/images/maquinas/ger-plana-2.jpg"
            ],
            specs: [
              { label: "Recorrido (X·Y·Z)", valor: "988 x 368 x 400 mm" }
            ]
          },
          {
            nombre: "Rectificadora cilíndrica universal",
            imagenes: ["/images/maquinas/cilindrica-1.jpg"],
            specs: [
              { label: "Diámetro", valor: "hasta Ø 450 mm" }
            ]
          }
        ]
      }
    ]
  },
  fresado: {
    slug: "fresado",
    nombre: "Fresado",
    descripcion:
      "Mecanizado de geometrías complejas con centros de fresado CNC de gran recorrido, capaces de trabajar piezas de grandes dimensiones con la máxima precisión.",
    grupos: [
      {
        titulo: null,
        maquinas: [
          {
            nombre: "DMG MORI NVX 5080 CNC",
            imagenes: [
              "/images/maquinas/dmgmori-1.jpg",
              "/images/maquinas/dmgmori-2.jpg",
              "/images/maquinas/dmgmori-3.jpg"
            ],
            specs: [
              { label: "Recorrido (X·Y·Z)", valor: "800 x 530 x 500 mm" }
            ]
          },
          {
            nombre: "AKIRA SEIKI CNC",
            imagenes: [
              "/images/maquinas/akiraseiki-1.jpg",
              "/images/maquinas/akiraseiki-2.jpg"
            ],
            specs: [
              { label: "Recorrido (X·Y·Z)", valor: "762 x 430 x 460 mm" }
            ]
          },
          {
            nombre: "CME CNC",
            imagenes: [
              "/images/maquinas/cme-1.jpg",
              "/images/maquinas/cme-2.jpg"
            ],
            specs: [
              { label: "Recorrido (X·Y·Z)", valor: "1200 x 750 x 750 mm" }
            ]
          }
        ]
      }
    ]
  },
  erosion: {
    slug: "erosion",
    nombre: "Erosión por Hilo",
    descripcion:
      "Servicio de electroerosión compuesto por dos tecnologías: electroerosión por hilo y electroerosión por penetración con electrodo, para el corte y mecanizado de precisión en cualquier material y dureza.",
    grupos: [
      {
        titulo: "Electroerosión por hilo",
        maquinas: [
          {
            nombre: "ONA AF35",
            imagenes: [
              "/images/maquinas/ona-af35-1.jpg",
              "/images/maquinas/ona-af35-2.jpg"
            ],
            specs: [
              { label: "Recorrido (X·Y·Z)", valor: "600 x 400 x 400 mm" }
            ]
          }
        ]
      },
      {
        titulo: "Electroerosión por penetración con electrodo",
        maquinas: [
          {
            nombre: "Electroerosión por penetración",
            imagenes: [
              "/images/maquinas/penetracion-1.jpg",
              "/images/maquinas/penetracion-2.jpg"
            ],
            specs: [
              { label: "Aplicación", valor: "Taladros en cualquier material y dureza" },
              { label: "Diámetro de taladro", valor: "desde Ø 0,5 a 6 mm" },
              { label: "Recorrido (X·Y·Z)", valor: "350 x 250 x 350 mm" }
            ]
          }
        ]
      }
    ]
  },
  grabado: {
    slug: "grabado",
    nombre: "Grabado Láser",
    descripcion:
      "Marcaje y grabado láser de precisión para la identificación y trazabilidad de piezas en distintos materiales.",
    grupos: [
      {
        titulo: null,
        maquinas: [
          {
            nombre: "Grabadora láser",
            imagenes: [
              "/images/maquinas/laser-1.jpg",
              "/images/maquinas/laser-2.jpg"
            ],
            specs: []
          }
        ]
      }
    ]
  }
};

export const partnersData = [
  {
    id: 1,
    nombre: "CMZ",
    logo: "/images/CMZ.png"
  },
  {
    id: 2,
    nombre: "DMG MORI",
    logo: "/images/DMG-MORI.png"
  },
  {
    id: 3,
    nombre: "GER",
    logo: "/images/GER.png"
  },
  {
    id: 4,
    nombre: "Mitutoyo",
    logo: "/images/Mitutoyo.png"
  },
  {
    id: 5,
    nombre: "ONA",
    logo: "/images/Ona.png"
  }
];

export const contactoData = {
  telefono: "+34 948 361 146",
  horario: "Lunes a Viernes de 9:00 a 20:00h",
  email: "microbat@microbat.es",
  tiempoRespuesta: "Respondemos en 24h",
  direccion: "Pol. Ind. de Egüés, Calle Z 16",
  codigoPostal: "C.P. 31486 Egüés (Navarra)",
  coordenadas: {
    lat: 42.82284452602503,
    lng: -1.563099381510561
  }
};

export const empresaData = {
  logo: "/images/MicroBat-Logo.png",
  logoBlanco: "/images/MicroBat-blanco.png",
  certificados: [
    { nombre: "AENOR", imagen: "/images/AENOR.png" },
    { nombre: "ISO", imagen: "/images/ISO.png" }
  ],
  sitioImagen: "/images/entrada.jpg"
};
